'use client';

import Image from 'next/image';
import React, { FC } from 'react';

import PartAccordion from '@/components/UI/part-accordion';
import { IContentImage } from '@/contentful/utils/contentImage';
import { IListItem } from '@/contentful/utils/listItem';

import IconLineLeft from './assets/icon-line-left-small.svg';

import styles from './part-faq-about-us.module.scss';

interface IPartFaqAboutUsProps {
  data: {
    category: string | undefined;
    title: string | undefined;
    image?: IContentImage | null;
    content: string[] | undefined;
    faqs: IListItem[];
  };
}

const PartFaqAboutUs: FC<IPartFaqAboutUsProps> = ({
  data: {
    category, title, image, content, faqs,
  },
}) => (
  <section className={styles.container}>
    <div>
      <div className={styles.imageWrap}>
        <Image
          src={image?.src ?? ''}
          alt={image?.alt ?? ''}
          width={image?.width ?? 0}
          height={image?.height ?? 0}
          className={styles.image}
          quality={75}
        />
        <div className={styles.experience}>
          <p className={styles.years}>{content ? content[0] : ''}</p>
          <p className={styles.label}>{content ? content[1] : ''}</p>
        </div>
      </div>
    </div>
    <div className={styles.content}>
      <div className={styles.categoryContainer}>
        <IconLineLeft />
        <p className={styles.category}>{category}</p>
      </div>
      <h2 className={styles.title}>{title}</h2>
      <PartAccordion list={faqs} />
    </div>
  </section>
);

export default PartFaqAboutUs;
